import { AeBoxAnchor, AeBoxVersion } from 'src/models/anchor-and-version/ae-box.model';
import { createBaseAnchor, createBaseVersion } from './base.factory';

export function createAeBoxAnchor(
    aParams: {
        // Base
        logText: string;
        // Specific
        aeAnchorKey: number;
        aedAnchorKey: number;
    },
    vParams: {
        // Base
        comment: string;
        logText: string;
        name: string;
        // Specific
        x: number;
        y: number;
        z: number;
        height: number;
        width: number;
    }
): AeBoxAnchor {
    const version = createAeBoxVersion({ ...vParams, anchorKey: 0, changeRequestKey: 1 });
    const anchor: AeBoxAnchor = {
        ...createBaseAnchor(aParams),
        aeAnchorKey: aParams.aeAnchorKey,
        aedAnchorKey: aParams.aedAnchorKey,
        displayName: null,
        allVersions: [version],
        validVersion: version,
    };

    return anchor;
}

export function createAeBoxVersion(params: {
    // Base
    anchorKey: number;
    changeRequestKey: number;
    comment: string;
    logText: string;
    name: string;
    // Specific
    x: number;
    y: number;
    z: number;
    height: number;
    width: number;
}): AeBoxVersion {
    const baseVersion = createBaseVersion(params);
    const version: AeBoxVersion = {
        ...baseVersion,
        x: params.x,
        y: params.y,
        z: params.z,
        height: params.height,
        width: params.width,
        name: params.name,
    };

    return version;
}
